import {Camera} from "features/apartmentViewer/types";
import {Euler, Vector3} from "three";
import {VectorHelper} from "features/apartmentViewer/ApartmentViewer/helpers/VectorHelper";

export class CameraModel {
    id: string;
    type: string;
    floorVerticalPosition: number;
    title: string;
    description: string;
    floorLevel: number;
    position: Vector3;
    rotation: Euler;
    hasQA: boolean;
    fieldOfView: number;

    constructor(camera: Camera) {
        this.id = camera.id;
        this.type = camera.type;
        this.floorVerticalPosition = parseFloat(camera.floorVerticalPosition);
        this.title = camera.title;
        this.description = camera.description;
        this.floorLevel = camera.floorLevel;
        this.position = VectorHelper.stringToThreeVector(camera.uposition);
        this.rotation = VectorHelper.stringToThreeEuler(camera.urotation);
        this.hasQA = camera.hasQA;
        this.fieldOfView = camera.fieldOfView;
    }

}
